import styled from 'styled-components'

export const Application = styled.div`
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
  color: rgb(20, 20, 20);
`
